/*
  Tesettür Paris — ürün sayfası davranışları.
  Yeni kütüphane yok; temanın slider-component, product-info ve product-form
  bileşenleri olduğu gibi kullanılıyor, bu dosya yalnızca onların üstüne biniyor.
*/

/* ---------- Mobil galeri nokta göstergesi ---------- */

class TpGaleriNoktalar extends HTMLElement {
  connectedCallback() {
    this.slider = document.getElementById(this.dataset.hedef);
    this.liste = this.slider && this.slider.querySelector('.product__media-list');
    if (!this.liste) return;

    this.ogeler = Array.from(this.liste.querySelectorAll('.product__media-item')).filter(
      (oge) => !oge.hasAttribute('hidden')
    );
    if (this.ogeler.length < 2) return;

    this.noktalar = this.ogeler.map((oge, i) => {
      const nokta = document.createElement('button');
      nokta.type = 'button';
      nokta.className = 'tp-galeri-noktalar__nokta';
      nokta.setAttribute('aria-label', this.etiket(i + 1, this.ogeler.length));
      nokta.addEventListener('click', () => this.git(i));
      this.appendChild(nokta);
      return nokta;
    });

    this.isaretle(1);
    this.slider.addEventListener('slideChanged', (olay) => this.isaretle(olay.detail.currentPage));
  }

  etiket(sira, toplam) {
    return (this.dataset.etiket || '')
      .replace('__SIRA__', sira)
      .replace('__TOPLAM__', toplam);
  }

  git(indeks) {
    const hedef = this.ogeler[indeks].offsetLeft - this.ogeler[0].offsetLeft;
    this.liste.scrollTo({ left: hedef, behavior: 'smooth' });
  }

  isaretle(sayfa) {
    this.noktalar.forEach((nokta, i) => {
      const etkin = i === sayfa - 1;
      nokta.classList.toggle('tp-galeri-noktalar__nokta--etkin', etkin);
      nokta.setAttribute('aria-current', etkin ? 'true' : 'false');
    });
  }
}

customElements.define('tp-galeri-noktalar', TpGaleriNoktalar);

/* ---------- Masaüstünde tıklayınca tam boy ---------- */
/*
  Modal yok. Görsel iki sütunluk akışta tek sütun kaplıyor; tıklanınca iki sütuna
  yayılıp tam boy görünüyor, tekrar tıklanınca geri dönüyor. Mobilde galeri zaten
  tam genişlik olduğu için bağlanmıyor.
*/
function tpTamBoyKur() {
  const liste = document.querySelector('.product__media-list');
  if (!liste || !window.matchMedia('(min-width: 750px)').matches) return;

  liste.querySelectorAll('.product__media-item').forEach((oge) => {
    const dugme = oge.querySelector('.product__media, .product__modal-opener, img');
    if (!dugme) return;
    oge.classList.add('tp-galeri__oge--acilir');
    oge.addEventListener('click', (olay) => {
      if (olay.target.closest('a')) return;
      oge.classList.toggle('tp-galeri__oge--tam');
    });
  });
}

/* ---------- Mobil yapışkan sepet çubuğu ---------- */
/*
  Çubuk kendi formunu kurmuyor; asıl butona tıklıyor. Fiyat ve buton etiketi sunucuda
  basılı geliyor (CLS için); burası yalnızca varyant değişiminde asıl alanlardan
  aynalıyor — product-info.js fiyatı yeniden bastığında MutationObserver tetikleniyor.
*/
function tpSepetCubuguKur() {
  const cubuk = document.querySelector('.tp-sepet-cubugu');
  if (!cubuk) return;

  const bolum = cubuk.dataset.bolum;
  const gercekButon = document.getElementById(`ProductSubmitButton-${bolum}`);
  if (!gercekButon) return;

  const fiyatKaynak = document.getElementById(`price-${bolum}`);
  const fiyatHedef = cubuk.querySelector('[data-tp-fiyat]');
  const buton = cubuk.querySelector('[data-tp-gonder]');

  const esitle = () => {
    if (fiyatKaynak) fiyatHedef.innerHTML = fiyatKaynak.innerHTML;
    buton.disabled = gercekButon.hasAttribute('disabled');
    const etiket = gercekButon.querySelector('span');
    buton.textContent = (etiket || gercekButon).textContent.trim();
  };

  cubuk.hidden = false;

  buton.addEventListener('click', () => gercekButon.click());

  const gozlemci = new MutationObserver(esitle);
  if (fiyatKaynak) gozlemci.observe(fiyatKaynak, { childList: true, subtree: true, characterData: true });
  gozlemci.observe(gercekButon, { attributes: true, childList: true, subtree: true });
}

function tpUrunKur() {
  tpTamBoyKur();
  tpSepetCubuguKur();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', tpUrunKur);
} else {
  tpUrunKur();
}
